/*
 * footer.js -- akordeon odkazovych sloupcu paticky (plan 07-05,
 * PREPSANO opravnou davkou 07-07, bod 6).
 *
 * JEDINA PRAVDA JE ATRIBUT `open`
 *
 * Do 07-06 byly pravdy dve: markup renderoval `<details>` BEZ `open` (tedy
 * "zavreno") a na desktopu obsah odkryval CSS selektor `::details-content`
 * (tedy "otevreno"). Kdyz se ty dve vypovedi rozesly, nemel merici nastroj
 * jak poznat, ktera plati -- a `::details-content` je navic Chrome 131+ /
 * Firefox 139+ / Safari 18.4+, tedy hluboko MIMO matici podpory (Safari
 * 14.1, Chrome 90, Firefox ESR 115). Na firemnim Firefoxu ESR, kvuli kteremu
 * matice existuje, mela desktopova paticka sloupce sbalene.
 *
 * Nove:
 *   - markup renderuje `<details open>` -- BEZ JS je obsah videt na vsech
 *     sirkach (funkcni vychozi stav; nativni `<details>` jde bez skriptu
 *     zavrit tapem na summary),
 *   - `init()` a zmena media query nastavi `open = mq.matches`: desktop
 *     otevreno, mobil zavreno,
 *   - `::details-content` z CSS zmizel uplne. Zadny feature-detect uz neni
 *     potreba, protoze `open` umi kazdy prohlizec z matice.
 *
 * PROC SE `apply()` NEVOLA PRI KAZDEM RESIZE
 * `matchMedia` hlasi `change` jen pri SKUTECNEM prekroceni breakpointu.
 * Uzivatelsky stav na mobilu (rucne rozbaleny sloupec) se proto pri otoceni
 * telefonu nebo vysunuti adresniho radku nezmeni -- prepise ho az prechod
 * pres 768 px. Posluchac na `resize` by ho shazoval po kazdem pixelu.
 *
 * SUMMARY NENI NA DESKTOPU OVLADACI PRVEK
 * Od 768 px je paticka mrizka a sloupce se nesbaluji. Kdyby summary zustalo
 * klikatelne, navstevnik by si sloupec omylem zavrel a dosavadni pojistka
 * (`toggle` listener, ktery ho hned zase otevrel) vyrabela viditelny zablesk
 * zavreno/otevreno. Misto leceni nasledku se proto prvek na desktopu
 * VYPINA: `preventDefault` na kliku, `tabindex="-1"` mimo tab poradi,
 * `cursor: default` v CSS. Na mobilu se zadny z techto zasahu nedeje --
 * summary tam zustava plne nativni.
 */

/** Selektor sbalitelnych sloupcu paticky (footer.php). */
const FACC = 'details.facc';

/**
 * Sirka, od ktere ma paticka vypadat jako dosud (research faze: „od 768
 * dnesni mrizka"). Musi sedet na breakpoint v chrome.css.
 */
const DESKTOP_MQ = '(min-width: 768px)';

/** Marker prvku, kterym tenhle modul nasadil `tabindex` (a jen tem). */
const TABINDEX_MARK = 'thFaccTabindex';

let mq = null;
let desktopBlocked = false;

/**
 * Nastavi vsem sloupcum `open`. Verejne kvuli meritelnosti: harness
 * `_07-footer-accordion.cjs` si tim overi obe polohy prepinace primo.
 *
 * @param {boolean} open Pozadovany stav.
 */
export function setAllOpen(open) {
	const columns = document.querySelectorAll(FACC);
	for (let i = 0; i < columns.length; i += 1) {
		columns[i].open = open;
	}
}

/**
 * Na desktopu summary nic neprepina -- klik se zahodi.
 *
 * @param {MouseEvent} event Udalost.
 * @return {void}
 */
function onSummaryClick(event) {
	if (!mq || !mq.matches) {
		return;
	}
	event.preventDefault();
}

/**
 * Zapne / vypne summary jako ovladaci prvek.
 *
 * `tabindex` se odebira jen tam, kde ho nasadil tenhle modul (marker) --
 * kdyby ho summary melo z jineho duvodu uz predtim, nesmi o nej prijit.
 *
 * @param {boolean} blocked true = desktop, summary nic neprepina.
 * @return {void}
 */
function setSummaryBlocked(blocked) {
	if (blocked === desktopBlocked) {
		return;
	}
	desktopBlocked = blocked;

	const summaries = document.querySelectorAll(`${FACC} > summary`);
	for (let i = 0; i < summaries.length; i += 1) {
		const s = summaries[i];
		if (blocked) {
			if (!s.hasAttribute('tabindex')) {
				s.setAttribute('tabindex', '-1');
				s.dataset[TABINDEX_MARK] = '1';
			}
		} else if (s.dataset[TABINDEX_MARK] === '1') {
			s.removeAttribute('tabindex');
			delete s.dataset[TABINDEX_MARK];
		}
	}
}

/**
 * Srovna stav sloupcu i ovladatelnost summary podle aktualniho pasma.
 *
 * @return {void}
 */
function apply() {
	setAllOpen(mq.matches);
	setSummaryBlocked(mq.matches);
}

/**
 * Nastartuje modul.
 *
 * Posluchac `click` visi na dokumentu v ZACHYTNE fazi: `<summary>` prepina
 * `open` nativne uz pri vlastnim zpracovani udalosti, takze bublani by
 * prislo pozde. Podminka na pasmo je uvnitr posluchace, ne kolem nej --
 * jeden posluchac po celou dobu je levnejsi a nema jak zustat viset po
 * prechodu zpet na mobil.
 */
export function init() {
	if (!window.matchMedia) {
		// Degradace (kontrakt B): bez matchMedia zustava markupovy stav
		// `open`, tedy vsechno viditelne. Zadna informace se neztrati.
		return;
	}

	mq = window.matchMedia(DESKTOP_MQ);

	document.addEventListener('click', function (event) {
		const target = event.target;
		if (!target || 'function' !== typeof target.closest) {
			return;
		}
		const summary = target.closest(`${FACC} > summary`);
		if (summary) {
			onSummaryClick(event);
		}
	}, true);

	apply();

	/* Safari 13/14 nema na MediaQueryList `addEventListener` (stejna vetev
	   jako v menu.js). */
	if (typeof mq.addEventListener === 'function') {
		mq.addEventListener('change', apply);
	} else if (typeof mq.addListener === 'function') {
		mq.addListener(apply);
	}
}
